export class Assemblage {
    static jsonMap = {
        annee: 'annee',
        volume: 'volume'
    };

    annee: number = undefined;
    volume: number = undefined;
}
